import { Table } from '@tanstack/react-table'
import clsx from 'clsx'
import styles from '../../Disruptions.module.scss'
import { Input } from '@/ui/Input'
import { Disruption, DisruptionStatus } from '@/types/disruptions'
import { Status } from '../Status'
import { useGetAreasRoutes } from '@/modules/Areas/hooks/useGetAreasRoutes'
import { TableFormDelayInput } from '@/modules/CombinedLogs'
import { DisruptionTypeInput } from './DisruptionTypeInput/DisruptionTypeInput'
import { DiversionRouteContainer } from './DiversionRouteSelector/DiversionRouteContainer'
import { NmccInput } from './NmccInput/NmccInput'
import { RouteSelectorContainer } from './RouteSelector/RouteSelectorContainer'
import { DateSelectContainer } from './DateSelect/DateSelectContainer'
import { Row } from '@tanstack/react-table'
import { UseFormReturn } from 'react-hook-form'
import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { RefObject } from 'react'

interface Props {
    row: Row<Disruption>
    table: Table<Disruption>
    form: UseFormReturn<DisruptionFormValues>
    editWrapperRef: RefObject<HTMLTableRowElement>
}

export const UpdateDisruptionForm = ({ row, table, form, editWrapperRef }: Props) => {
    const { areaRoutes } = useGetAreasRoutes()

    return (
        <>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr className={clsx(styles.formRow, styles.active)} key={headerGroup.id} ref={editWrapperRef}>
                    <td className={clsx(styles.formCell, styles.alignCenterFormCell)} key={'status'}>
                        <div className={styles.statusContainer}>
                            <Status isHeader status={form.getValues('status') as DisruptionStatus} />
                        </div>
                    </td>
                    <td className={clsx(styles.formCell, styles.alignCenterFormCell)} key={'reference'}>
                        <div className={styles.reference}>{row.original.reference}</div>
                    </td>
                    <td className={styles.formCell} key={'routes'}>
                        <RouteSelectorContainer form={form} areaRoutes={areaRoutes.map((route) => route.route)} />
                    </td>
                    <td className={styles.formCell} key={'location'}>
                        <Input
                            {...form.register('location')}
                            variant="table"
                            type="text"
                            transparent
                            fullWidth
                            placeholder={'Location'}
                        />
                    </td>
                    <td className={clsx(styles.formCell, styles.alignCenterFormCell)} key={'details'}>
                        <div>
                            <Input
                                {...form.register('details')}
                                variant="table"
                                type="text"
                                transparent
                                fullWidth
                                placeholder={'Details'}
                            />

                            <DiversionRouteContainer form={form} />
                        </div>
                    </td>
                    <td className={styles.formCell} key={'disruptionType'}>
                        <DisruptionTypeInput form={form} />
                    </td>
                    <td className={styles.formCell} key={'nmccInformed'}>
                        <NmccInput form={form} />
                    </td>
                    <td className={styles.formCell} key={'delayInMinutes'}>
                        <TableFormDelayInput name="delayInMinutes" control={form.control} />
                    </td>

                    <DateSelectContainer  form={form} />

                    <td className={styles.formCell} key={'menu'}></td>
                </tr>
            ))}
        </>
    )
}
